import React, {useRef, useState} from 'react'
import {Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Modal, Row} from "reactstrap"
import {useSelector} from "react-redux";
import * as Yup from "yup";
import {useForm} from "react-hook-form";

// components
import {GenericButton} from "../../../../components/buttons/customButtons";
import {GenericTableButton} from "../../../../components/buttons/buttonsActions";
import Separator from "../../../../components/Separator";
import {LogHistoryModal} from "../../../../components/logHistory/logHistoryModal";
import Switch from "react-bootstrap-switch";
import WidgetLangs from "../../widget/_langs";

// labels
import {FORM, INTERNATIONAL, LB_BACKGROUND, LB_CODE,LB_STATUS, REQUIRED} from "../../../../components/i18n/i18n";
import {TT_CLOSE, TT_HISTORY, TT_SAVE} from "../../../../components/i18n/toolTips";
import {PH_BACKGROUND, PH_CODE} from "../../../../components/i18n/placeHolders";

// utils
import {getStateByPath} from "../../../../redux/selectors";

// actions
import {genericIndexedActions} from "../../../../redux/actions/generics/GenericIndexedActions";

// services
import {widgetService} from "../../../../jwt/_services/landings/widgetService";
import {sectionWidgetService} from "../../../../jwt/_services/landings/sectionWidgetService";
import {getCurrentDateForCodeField} from "../../../../util/DateTools";
import ModalFormTitle from "../../../../components/genericComponents/ModalFormTitle";


const WidgetForm = (props) => {
    const parentState = useSelector(state => getStateByPath(state, props.path));
    const { domainObject:section, app } = parentState?.data || {};

    const path = `${props.path}/widgets`;
    const componentState = useSelector(state => getStateByPath(state, path));
    const {  listDomainObjects } = componentState?.data || [];
    const { editMode, domainObject} = componentState?.data;

    const {fbDataBase} = app

    const translatableLangs = domainObject?.translatedLangs || []

    const [status, setStatus] = useState(domainObject?.status || true);
    const [langs, setlangs] = useState(domainObject?.langs || []);
    const [showModal, setShowModal] = useState(true)

    const modalRef = useRef(null);


    const validationSchema = Yup.object().shape({
        code: Yup.string().required( REQUIRED ),
    });

    const { register, handleSubmit, reset, errors } = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            id: domainObject?.id,
            code: (domainObject?.code || `WIDGET_` + getCurrentDateForCodeField()).toLowerCase(), // AUTOCODE
            background: domainObject?.background,
            showOrder: domainObject?.showOrder || (listDomainObjects.length + 1),
        }
    });

    const onSubmit = async (data, _) => {
        let labelRequest = {
            fbDataBase,
            item : {
                ...data,
                status: !!status,
                showOrder: (listDomainObjects.length + 1),
                langs
            }
        };

        if(editMode){
            labelRequest.item.id = domainObject?.id
            await widgetService.updateItem(domainObject?.id, labelRequest) // actualizar la amenidad
            return
        }

        const widgetResponse = await widgetService.saveItem(labelRequest) // guardar la amenidad

        const requestData = {
            fbDataBase,
            item: {
                section: { id: section?.id },
                widget: { id: widgetResponse?.id },
                showOrder: (listDomainObjects.length + 1),
            }
        }

        genericIndexedActions.save(path, sectionWidgetService, requestData, closeForm) // vincular la amenidad con el tipo de habitación

    };

    const showHistory = () => {
        setShowModal(true);
        modalRef.current.showModal(domainObject);
    }


    const closeForm = () => {
        reset();
        props.toggle()
    }

    return <Modal
        isOpen={props.isOpen}
        toggle={props.toggle}
        keyboard={false}
        modalClassName="menu-modal-form"
    >
        <Form onSubmit={handleSubmit(onSubmit)}>
            <Card className={'card-modal'}>
                <CardTitle className="bg-light border-bottom p-3 mb-0">
                    <ModalFormTitle
                        domainObject={domainObject}
                        editMode={editMode}
                    />
                    <div className={'top-right'}>
                        <GenericButton
                            style={'table'}
                            icon={'fa-save'}
                            toolTip={TT_SAVE}
                            permission={'add'}
                            type={'submit'}
                        />
                        {
                            editMode && <>
                                <GenericTableButton
                                    toolTip={TT_HISTORY}
                                    icon={'fa-clock'}
                                    permission={'search'}
                                    onClick={showHistory}
                                />
                            </>
                        }
                        <Separator/>
                        <GenericButton
                            style={'danger-secondary'}
                            toolTip={TT_CLOSE}
                            icon={'fa-times'}
                            permission={'search'}
                            onClick={closeForm}
                        />
                    </div>
                </CardTitle>
                <CardBody className={'card-body-modal'}>
                    <Row>
                        <Col>
                            <FormGroup>
                                <Label>{LB_CODE}</Label>
                                <Input
                                    type="text"
                                    name="code"
                                    placeholder={PH_CODE}
                                    innerRef={register}
                                />
                                {errors.code && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.code?.message}</div>}
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <Label>{LB_BACKGROUND}</Label>
                                <Input
                                    type="text"
                                    name="background"
                                    placeholder={PH_BACKGROUND}
                                    innerRef={register}
                                />
                                { errors.background && <div className="invalid-feedback" style={{'display':'block'}}>{errors?.background?.message}</div>}
                            </FormGroup>
                        </Col>
                        <Col md="2">
                            <FormGroup>
                                <Label>{LB_STATUS}</Label>
                                <br/>
                                <Switch
                                    animate={true}
                                    offText={"No"}
                                    onText={"Si"}
                                    value={status}
                                    onChange={ () => setStatus(!status) }
                                />
                            </FormGroup>
                        </Col>
                    </Row>

                    <CardTitle className="bg-light border-bottom p-3 mb-0">
                        <i className="fas fa-language mr-2"/>
                        { INTERNATIONAL }
                    </CardTitle>
                    <CardBody>
                        <WidgetLangs
                            langs={langs}
                            setLangs={setlangs}
                            translatableLangs={translatableLangs}
                        />
                    </CardBody>
                </CardBody>

                {
                    showModal && <LogHistoryModal
                        ref={modalRef}
                        item={domainObject}
                    />
                }
            </Card>
        </Form>
    </Modal>
}

export default WidgetForm;